<template>
  <div class="col-12 col-lg-8 c g">
    <div class="card">
        <div class="card-header">
            <div>
                <i class="fa fa-plus"></i>
                إنشاء ملف إنجاز
            </div>
        </div>
        <div class="card-body">
            <div class="form-group">
              <h5 for="">عنوان الملف</h5>
              <input type="text"
                class="form-control form-control-lg" v-model="title" placeholder="مثل: ملف ١...">
                <small class="text-muted">ليسهل عليك تمييز الملف اذا كان لديك اكثر من ملف.</small>
            </div>
            <div class="form-group">
              <h5 for="">اسم مدير المدرسة</h5>
              <input type="text"
                class="form-control form-control-lg" v-model="school_admin" placeholder="اسم المدير هنا...">
            </div>
            <div class="form-group">
              <h5 for="">نوع الملف</h5>
              <select class="form-control form-control-lg" v-model="type">
                <option value="1">معلم</option>
                <option value="2">معلم مسند له نشاط طلابي</option>
                <option value="3">معلم مسند له توجيه صحي</option>
                <option value="4">محضر مختبر</option>
                <option value="5">معلمة رياض أطفال</option>
                <option value="6">الوكيل والمدير</option>
                <option value="7">الموجه الطلابي</option>
              </select>
            </div>
            <div class="col-12 text-center">
                <button class="btn btn-danger" @click="done()">
                    إنشاء الملف الآن
                </button>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            user: JSON.parse(localStorage.getItem("user")),
            title: "",
            school_admin: "",
            admin_phone: "",
            type: '1'
        }
    },
    methods: {
        done(){
            var g = this;
            $.post(api + '/user/files/create', {
                jwt: g.user.jwt,
                type: g.type,
                title: g.title,
                school_admin: g.school_admin,
                admin_phone: g.admin_phone
            }).then(function(r){
                if(r.status == 100){
                    g.$router.push(`/file/${r.response}`)
                }else{
                    alert(r.response, 200)
                }
            })
        }
    }
}
</script>

<style>

</style>